
import { useState, useEffect } from "react"
import { Link, useNavigate } from "react-router-dom"
import AuthLayout from "../../../components/layout/AuthLayout"
import Button from "../../../components/ui/Button"
import FormInput from "../../../components/layout/FormInput"

export default function CreatePatientAccount() {
  const navigate = useNavigate()
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [countdown, setCountdown] = useState(2)
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
    additionalComments: "",
  })
  const [errors, setErrors] = useState({})

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
    // Clear error for this field when user types
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }))
    }
  }

  const validateForm = () => {
    const newErrors = {}

    Object.keys(formData).forEach((key) => {
      if (key !== "additionalComments" && !formData[key].trim()) {
        newErrors[key] = "This field is required"
      }
    })

    if (formData.phoneNumber && !/^[+]?[\d\s()-]{8,}$/.test(formData.phoneNumber)) {
      newErrors.phoneNumber = "Please enter a valid phone number"
    }

    if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Please enter a valid email address"
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    if (validateForm()) {
      

      // Set submitted to true to trigger the redirect
      setIsSubmitted(true)
    }
  }

  

  return (
    <AuthLayout
      title=""
      subtitle=""
      logoSrc="/img/logo.png"
      imageSrc="/img/Oshimed sign in image - earth.png"
      formWidth="half"
      contentPadding="small"
      maxWidth="full"
    >
      <div className="rounded-xl p-6 w-full">
            <h2 className="text-2xl font-semibold mb-6 text-center">
              Creating an account on Oshimed requires prior authorization
            </h2>
            <p className="text-center text-gray-600 mb-6">
              If you wish to use the platform, please submit a request using the form below.
            </p>
            <form className="space-y-4 w-full" onSubmit={handleSubmit}>
              {/* First name and Last name */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <FormInput
                  label="First name"
                  id="firstName"
                  name="firstName"
                  type="text"
                  placeholder="First name"
                  required
                  value={formData.firstName}
                  onChange={handleChange}
                  error={errors.firstName}
                />
                <FormInput
                  label="Last name"
                  id="lastName"
                  name="lastName"
                  type="text"
                  placeholder="Last name"
                  required
                  value={formData.lastName}
                  onChange={handleChange}
                  error={errors.lastName}
                />
              </div>

              {/* Phone number and Email */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <FormInput
                  label="Phone number"
                  id="phoneNumber"
                  name="phoneNumber"
                  type="tel"
                  placeholder="+1 24 61 23 76 54"
                  required
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  error={errors.phoneNumber}
                />
                <FormInput
                  label="Email address"
                  id="email"
                  name="email"
                  type="email"
                  placeholder="name@email.com"
                  required
                  value={formData.email}
                  onChange={handleChange}
                  error={errors.email}
                />
              </div>

            {/* Additional comments */}
            <div className="grid grid-cols-1 gap-4 w-full">
          <FormInput
            label="Additional Comments"
            id="additionalComments"
            name="additionalComments"
            type="text"
            placeholder="Optional"
            
          />
        </div>

              {/* Send button */}
              <div className="mt-6 flex justify-center">
                <Button type="submit" variant="login" className="">
                  Send
                </Button>
              </div>
            </form>

            {/* Footer message */}
            <div className="mt-6 text-center">
              <p className="text-gray-600 text-sm">Our team will review your information and get back to you.</p>
            </div>

            {/* Terms and conditions */}
            <div className="mt-4 text-center">
              <p className="text-gray-600 text-sm">
                By creating an account, you agree to Oshimed's{" "}
                <Link to="/conditions-of-use" className="text-linkColor">
                  Conditions of use
                </Link>
              </p>
            </div>
      </div>
    </AuthLayout>
  )
}
